<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-toolbar flat height="90">
                <v-btn
                    :disabled="!getPermission('suppliers.create')"
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.createSupplier[lang]"
                    @click="openCreateModal()"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-col cols="12" sm="4" class="pa-0">
                    <b-search-field></b-search-field>
                </v-col>
            </v-toolbar>

            <v-data-table
                :headers="headers"
                :items="suppliers"
                :loading="loading"
                class="b-outlined"
                hide-default-footer
            >
                <template v-slot:item.actions="{ item }">
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                            :disabled="!getPermission('suppliers.delete')"
                                color="red"
                                icon
                                v-on="on"
                                @click="() => {
                                    deletingSupplierId = item.supplier_store_id
                                    deleteDialog = true
                                }"
                            >
                                <v-icon v-text="icons.mdiClose"></v-icon>
                            </v-btn>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.delete[lang]"
                        ></span>
                    </v-tooltip>
                </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600">
                <SupplierForm @cancel="dialog = false" />
            </v-dialog>

            <v-dialog v-model="deleteDialog" max-width="500">
                <b-card
                    type="delete"
                    title="Delete Supplier"
                    :submit-text="{ el: '', en: 'delete', it: '' }"
                    @cancel="deleteDialog = false"
                    @submit="remove"
                >
                    <div class="subtitle-1 font-weight-medium py-3">
                        Are you sure you want to delete
                        <span class="font-weight-bold text--primary">Supplier</span>?
                    </div>
                </b-card>
            </v-dialog>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";

import SupplierForm from "@/components/loyaltyPanel/supplierManagement/SupplierForm";
import translations from "@/utils/translations/loyaltyPanel/supplierManagement";

export default {
    name: "SupplierManagement",

    components: { SupplierForm },

    mixins: [translations],

    data: () => ({
        icons: { mdiPencilOutline, mdiClose },
        deletingSupplierId: null
    }),

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        
        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                { 
                    text: this.translations.name[this.lang], 
                    value: "name" 
                },
                { 
                    text: this.translations.mobile[this.lang], 
                    value: "mobile" 
                },
                { 
                    text: this.translations.primary_email[this.lang], 
                    value: "supplier_settings.primary_email" 
                },
                { 
                    text: this.translations.secondary_email[this.lang], 
                    value: "supplier_settings.secondary_email" 
                },
                { 
                    text: this.translations.actions[this.lang], 
                    value: "actions" 
                }
            ];
        },

        suppliers: {
            get() {
                return this.$store.state.loyaltyPanel.supplierManagement.suppliers;
            }
        },

        deleteDialog: {
            get() {
                return this.$store.state.deleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            },
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        }
    },

    methods: {
        ...mapActions(["getPermission"]),
        ...mapActions("loyaltyPanel/supplierManagement", ["getSuppliers","delete"]),
        ...mapMutations([
            "setDialog",
            "setDeleteDialog",
            "setResetSuccess",
            "setResetValidation",
        ]),

        openCreateModal(){
            this.dialog = true;
            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
        },

        remove(){
            this.delete(this.deletingSupplierId);
        }
    },

    mounted(){
        this.getSuppliers()
    }

};
</script>

<style scoped>
.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
